export const STUDENT_CLASS_JOIN_ROUTE = '/join/class/:inviteCode';
export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

export const buildStudentClassInvitePath = (inviteCode) => (
  `/join/class/${encodeURIComponent(inviteCode)}`
);

export const getPostLoginRedirect = () => {
  const redirect = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  return redirect && /^\/join\/class\/[^/?#]+$/.test(redirect) ? redirect : null;
};
